/**
 * Normalizes an assertionBaseUrl value from the database into a full https:// URL.
 *
 * Handles three input formats:
 * - Full URL with protocol: "https://bank1672000.dev1loan.payrailzdev.com" → returned as-is (origin only)
 * - Hostname without protocol: "bank1672000.dev1loan.payrailzdev.com" → prepends https://
 * - Bare subdomain: "bank1672000" → expands using current hostname to detect environment
 */

const LOCALHOST_ALLOWED_ENVS = ['dev1', 'dev2', 'dev3', 'qa1', 'qa2'];

export default function normalizeAssertionBaseUrl(raw) {
  if (!raw) return raw;

  // Already a full URL — normalize origin only
  if (/^https?:\/\//i.test(raw)) {
    try {
      return new URL(raw).origin;
    } catch (_e) {
      return raw;
    }
  }

  // Has dots — treat as hostname, prepend https
  if (/\./.test(raw)) {
    try {
      return new URL(`https://${raw.replace(/^\/*/, '')}`).origin;
    } catch (_e) {
      return raw;
    }
  }

  // Bare subdomain — expand using current hostname to detect environment
  const host = window.location.hostname;
  const match = host.match(
    /^([a-z0-9]*)ontrac\.payrailz(dev|test|prod)?\.com$/i
  );
  if (match) {
    const environmentSuffix = match[2] || '';
    return `https://${raw}.${match[1]}loan.payrailz${environmentSuffix}.com`;
  }
  if (host === 'localhost' || host === '127.0.0.1') {
    const clientEnv =
      typeof process !== 'undefined' &&
      process.env &&
      process.env.REACT_APP_CLIENT_ENV;
    const env =
      clientEnv && LOCALHOST_ALLOWED_ENVS.includes(clientEnv)
        ? clientEnv
        : 'dev1';
    return `https://${raw}.${env}loan.payrailzdev.com`;
  }
  return raw;
}
